import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ExternalSearchService } from '../../../services/external-search.service';

@Component({
  selector: 'gen-external-search-details',
  templateUrl: 'external-search-details.component.html',
  styleUrls: ['external-search-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalSearchDetailsComponent implements OnInit {
  public searchSwitchedStatus: { [key: string]: boolean; } = { };
  public searchQuery: string = '';
  @Input() data: { [key: string]: string; };
  @Input() buttonText: string = 'Search';
  @Input() searchFormConfigParams: any;
  @Input() searchDataConfigParams: any;
  @Input() searchURL: string;
  public searchParamsStr: string;

  @Input() set shown(isShown: boolean) {
    if (isShown) {
      this.setSearchQuery();
    }
  }

  constructor(private externalSearchService: ExternalSearchService) { }

  ngOnInit() {
    this.searchSwitchedStatus = this.externalSearchService.getDefaultStatus(this.searchFormConfigParams);
  }

  toggleSelection(value, fieldName: string) {
    this.searchSwitchedStatus[fieldName] = value;
    this.setSearchQuery();
  }

  searchClicked($event) {
    this.setSearchQuery();
    window.open(this.searchQuery, '_blank');
  }

  setSearchQuery() {
    this.searchQuery = this.externalSearchService.getSearchQueryBySwitches(
      this.searchURL,
      this.searchDataConfigParams,
      this.data,
      this.searchSwitchedStatus
    );
    // Show only parameters without the URL
    this.searchParamsStr = this.searchQuery.replace(this.searchURL, '');
  }
}
